var $ = require("lc-jquery");
var Modal = require("ui-modal");
// var endDateString = require('dynamic-module-registry').get('siteConfig').firstVisitModalEndDate;
// var today = new Date();
// var endDate = new Date(endDateString);
// var isYTS = require('dynamic-module-registry').get('siteConfig').isYTS;

var firstVisitModal = new Modal($("#first-visit-modal"));

$("#myModalCloseBtn").on("click", function () {
  firstVisitModal.hide();
});

// FUNCTIONALITY TURNED OFF - keeping this code as a module for possible future use.
/*
function showFirstVisitModal () {
  if (isYTS) {
    return;
  }
  if ( today >= endDate || document.cookie.indexOf('firstVisitModal') >= 0) {
    return false;

  } else {
    document.cookie = "firstVisitModal=no; expires=" + endDate.toUTCString();
    return true;
  }
}
*/
// $(document).ready(function() {
//   if (showFirstVisitModal()) {
//     firstVisitModal.show();
//   }
// });

// Export the public interface of the module.
// Can be an object or a function(), which will have 'new' called on it
module.exports = {};

require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/src/shared_modules/first-visit-modal/first-visit-modal.less');